import { useParams } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const PAGES = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Placeholder — replace with your privacy policy before launch.",
      "We process personal data you provide (name, contact details and uploaded documents) solely to prepare quotations and deliver translation services. Documents are stored securely and handled confidentially.",
      "You may request access, correction or deletion of your personal data at any time by contacting us.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "Placeholder — replace with your terms and conditions before launch.",
      "Quotations are indicative until confirmed in writing by our team. Projects begin once the quotation is accepted and payment is received through our secure payment provider.",
      "Delivery estimates are provided in good faith and confirmed per project.",
    ],
  },
  cookies: {
    title: "Cookie Policy",
    body: [
      "Placeholder — replace with your cookie policy before launch.",
      "This website uses essential cookies required for core functionality. Analytics or marketing cookies, if introduced, will be listed here with controls.",
    ],
  },
  faq: {
    title: "Frequently Asked Questions",
    body: [
      "How do I get a quote? — Upload your documents and select your languages in the quote tool. You will receive an indicative estimate instantly or a confirmed quotation from our team.",
      "How do I pay? — Once you approve your quotation, you receive a secure payment link. Payment is processed through our established payment infrastructure.",
      "Are my documents confidential? — Yes. Documents are stored securely and handled confidentially throughout the translation process.",
      "Which file formats do you accept? — PDF, DOCX, XLSX, PPTX, JPG and PNG, among others.",
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const page = PAGES[slug] || PAGES.privacy;
  return (
    <div data-testid={`legal-${slug}`} className="bg-[#FAF8F5] min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-8 pt-36 pb-24">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C87A4B] mb-4">TranslateIt</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0B111E] mb-10">{page.title}</h1>
        <div className="flex flex-col gap-5">
          {page.body.map((p, i) => (
            <p key={i} className="text-base leading-relaxed text-slate-600">{p}</p>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
